import React, { useState, useEffect } from 'react';
import {
  HeaderContainer,
  HeaderContent,
  Logo,
  LogoImage,
  Nav,
  NavLink,
  MenuIcon,
  Dropdown,
  DropdownContent,
  DropdownToggle,
  NavLinkGetInvolved
} from './Header.styles';
import { FaBars, FaTimes, FaChevronDown, FaChevronUp, FaUserLock } from 'react-icons/fa';
import hbiLogo from '/icons/hbi-logoo.svg';
import debounce from 'lodash/debounce';
import { useLocation, Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    const debounceShowHeader = debounce(() => {
      setIsHidden(false);
    }, 300);

    const handleScroll = () => {
      setIsHidden(true);
      debounceShowHeader();
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      debounceShowHeader.cancel();
    };
  }, []);

  // Close the menu when navigating to a new page
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  return (
    <HeaderContainer $isHidden={isHidden}>
      <HeaderContent>
        <Link to="/">
          <Logo>
            <LogoImage src={hbiLogo} alt="Hope Beyond International Logo" />
          </Logo>
        </Link>

        <MenuIcon onClick={toggleMenu} aria-label="Toggle navigation menu">
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </MenuIcon>

        <Nav $isMenuOpen={isMenuOpen} aria-label="Main Navigation">
          <NavLink to="/" $isActive={location.pathname === '/'}>
            Home
          </NavLink>
          <NavLink to="/about" $isActive={location.pathname === '/about'}>
            About Us
          </NavLink>
          <NavLink to="/missions" $isActive={location.pathname === '/missions'}>
            Missions
          </NavLink>

          <Dropdown>
            <DropdownToggle onClick={toggleDropdown}>
              <NavLinkGetInvolved to="#">
                More
              </NavLinkGetInvolved>
              {isDropdownOpen ? <FaChevronUp /> : <FaChevronDown />}
            </DropdownToggle>

            <DropdownContent $isDropdownOpen={isDropdownOpen}>
              <NavLink to="/events" $isActive={location.pathname === '/events'}>
                Events
              </NavLink>
              <NavLink to="/volunteer" $isActive={location.pathname === '/volunteer'}>
                Volunteer
              </NavLink>
              <NavLink to="/resources" $isActive={location.pathname === '/resources'}>
                Resources
              </NavLink>
              <NavLink to="/contact-us" $isActive={location.pathname === '/contact-us'}>
                Contact Us
              </NavLink>
              <NavLink 
                to="/login" 
                $isActive={location.pathname === '/login'} 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  gap: '8px',
                  borderTop: '1px solid rgba(0,0,0,0.1)',
                  marginTop: '5px',
                  paddingTop: '8px'
                }}
              >
                <FaUserLock size={14} />
                Login
              </NavLink>
            </DropdownContent>
          </Dropdown>

          <NavLink to="/donate" $primary $isActive={location.pathname === '/donate'}>
            Donate
          </NavLink>
        </Nav>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;